/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Link_Pin_Drop_WarningInputs */



/**
* | output |
* | --- |
* | "This link is pinned. Changing its address unpins it until an official pins it again." |
*
* @param {Community_Link_Pin_Drop_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_link_pin_drop_warning = /** @type {((inputs?: Community_Link_Pin_Drop_WarningInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Link_Pin_Drop_WarningInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce lien est épinglé. Changer son adresse le désépingle jusqu'à ce qu'un officiel l'épingle à nouveau.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Este enlace está fijado. Cambiar su dirección lo desfija hasta que un oficial lo vuelva a fijar.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Este link está fixado. Mudar o endereço o desafixa até um oficial fixá-lo de novo.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo link è fissato. Cambiarne l'indirizzo lo sblocca finché un ufficiale non lo fissa di nuovo.")
	return /** @type {LocalizedString} */ ("This link is pinned. Changing its address unpins it until an official pins it again.")
});